import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const AddFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M17.38 20.1H6.62C4.86 20.1 3.86 19.1 3.86 17.34V6.58C3.86 4.82 4.86 3.82 6.62 3.82H17.38C19.14 3.82 20.14 4.82 20.14 6.58V17.34C20.14 19.1 19.14 20.1 17.38 20.1ZM15.74 12.78V11.12H12.82V8.22H11.18V11.12H8.26V12.78H11.18V15.7H12.82V12.78H15.74Z" />
    </SvgIcon>
  );
});
